import React from 'react';
import { History } from 'history';
import { Chip, GridContainer, InputFile, InputSelect, InputUID } from '../../components';
import BaseShare from '../base/base-share.component';
import BaseView from '../base/base-view.component';
import Model from './event-model';  //editable..
import MessageModel from '../message/message-model';
import UserAuthGetToken from '../user/user-auth-gettoken.component';
import PersonalinfoChecklist from '../personalinfo/personalinfo-checklist.component';
import MessageCopy from '../message/message-copy.component';
import ReportPreview from '../report/report-preview.component';

interface IProps { 
    history: History;
    id?: number;
    caption?: string;
    buttonCaption?: string;
    processCaption?: string;
    participantId?: number;
    reportId?: number;
    dataSource?: any;
    to?: string;
    astemplate?: string;
    save?: boolean;
    onSave?: (data: any) => void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMessage: MessageModel;
    messageId: number;
    messageText: string;
    messageType: string;
    attachment: any;
    attachmentUrl: string;
    needToken: boolean;
    job: string;
    saveOrder: number;
}

export default class EventShare extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMessage: MessageModel.defaultValue(),
            messageId: 0,
            messageText: '',
            messageType: 'email',
            attachment: null,
            attachmentUrl: '',
            needToken: false,
            job: '',
            saveOrder: -1,
        }
        
        this.onChange = this.onChange.bind(this);
    }

    private link = window.location.origin + Model.url + '/';

    private onLoad = (data: any) => {
        const messageId = this.props.reportId? data.messageend : data.messagestart;
        this.setState({datarow: data, messageId: messageId});
    }

    private onLoadMessage = (data: any) => {
        this.setState({datarowMessage: {...data, id: 0}, messageText: data?.text, messageType: data?.type, needToken: data.text.includes('[link]')});
    }

    private onLoadParticipant = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'participant': data || [], 'participantLength': data?.length || 0} });
    }

    private onLoadFile = async(data: any) => {
        await this.setState({ datarowMessage: {...this.state.datarowMessage, attachment : data}, job : this.props.reportId? (this.state.needToken? 'token' : 'message') : ''});
    }

    private onSaveToken = async(data: any) => {
        const link = this.link +  this.state.datarow.uid + '?t=' + data.code;
        const text = this.state.datarowMessage.text.replace('[link]', link);
        await this.setState({ datarowMessage: {...this.state.datarowMessage, text: text, html: text.replaceAll('\n','<br/>')}, job : 'message'});
    }
    
    private onErrorToken = (data: any) => {
        if (data) this.onSaveMessage(data);
    }

    private onErrorMessage = (data: any) => {
        if (data) this.onSaveMessage(data);
    }

    private onSaveMessage = (data: any) => {
        this.saveMessage(this.state.saveOrder - 1);
    }

    private onSave = (data: any) => {
        this.saveMessage(this.state.datarow.participantLength - 1);
    }

    private saveMessage = async(saveOrder: number) => {
        var d = this.state.datarow.participant?.[saveOrder];
        const to = this.props.to || (this.state.messageType==='email'? d?.email : d?.phone);
        const text = this.state.messageText.replace('[event]', this.state.datarow.name).replace('[name]', d?.name);
        d = d && to? {id: this.state.messageId, name:'', description:'', type: this.state.messageType, astemplate: 'no', sent: 'yes', to: to, text: text } : {id: 0} 
        await this.setState({ datarowMessage: {...this.state.datarowMessage, ...d}, saveOrder: saveOrder, job: this.props.reportId? 'report' : this.state.needToken? 'token' : 'message'})
    }

    private onChange(fieldName: string, value?: string) {
        const nextState = {
            ...this.state, [fieldName]: value
        }
        this.setState(nextState);
    }

    render() {
        return(
            //editable..
            <>
            <BaseShare history={this.props.history} id={this.props.id} caption={this.props.disableView? ' ' : ''} buttonCaption={this.state.saveOrder>=0 && this.props.disableView? 'Proccessing ...' : this.props.buttonCaption || (this.props.disableView || this.state.datarow.participantLength===0? ' ' : '')}
                endPointFilter={Model.endPointFilter3(this.props.participantId)} model={Model} onLoad={this.onLoad} save={this.props.save && this.state.saveOrder < 0} onSave={this.onSave} disableAutoBack disableBackButton={this.props.disableView} disableCard={this.props.disableView}>  

                {this.state.messageId > 0 &&
                <BaseView id={this.state.messageId} caption='' 
                    model={MessageModel} onLoad={this.onLoadMessage}/>
                }
                
                {!this.props.disableView && 
                <>
                    {this.state.messageId > 0?
                    <>
                    <GridContainer>
                        <InputSelect name='messageType' label=' ' value={this.state.messageType} options={MessageModel.optionType} error={this.state.errors?.type} onChange={this.onChange}/>
                        {!!this.state.datarow.uid &&
                        <InputUID name='uid' label=' ' value={this.state.datarow.uid} size={-1} link={this.link} error={this.state.errors?.attachment} onChange={this.onChange}/>
                        }
                    </GridContainer>
                    <InputFile name='attachmentUrl' label=' ' value={this.state.attachmentUrl} onLoad={this.onLoadFile} encode error={this.state.errors?.attachment} onChange={this.onChange} disableMargin/>
                    <PersonalinfoChecklist history={this.props.history} caption=' ' currentId={this.state.datarow.participant} personalinfotypeType='customer' onLoad={this.onLoadParticipant} selectedOnly disableBackButton disableCard/>
                    </>
                    : this.state.datarow.id > 0 &&
                    <GridContainer position='center'><Chip label='This event does not have the default messages yet.' type='error'/></GridContainer>
                    }
                </>
                }
            </BaseShare>

            {this.state.datarowMessage.id > 0 &&
            <>
            {this.state.job==='report' && <ReportPreview history={this.props.history} id={this.props.reportId} proccessCaption={this.props.processCaption} save onLoadFile={this.onLoadFile} disableView/>}
            {this.state.job==='token' && <UserAuthGetToken history={this.props.history} useremail={this.state.datarow.participant?.[this.state.saveOrder]?.userEmail} successCaption='Link Created' save onSave={this.onSaveToken} onError={this.onErrorToken}/>}
            {this.state.job==='message' && <MessageCopy history={this.props.history} id={this.state.datarowMessage.id} successCaption='Message Sent' datarow={this.state.datarowMessage} onError={this.onErrorMessage} save onSave={this.onSaveMessage} disableView/>}
            </>
            }
        </>
        )
    }
}